var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "navigateable-tab",
    [
      [
        _c("div", [
          _c("h3", { staticClass: "category-title" }, [
            _vm._v(
              _vm._s(_vm.resource("AudienceManager_Builder_Quickstart_Title"))
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "question-container" }, [
            _c(
              "label",
              {
                staticClass: "question-name",
                attrs: { for: "audience-csv-upload" }
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(
                      _vm.resource("AudienceManager_Builder_CSVUpload_Label")
                    ) +
                    " *\n                "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "question-content" },
              [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-outline-secondary question-input",
                    attrs: { disabled: !_vm.isNewAudience },
                    on: {
                      click: function($event) {
                        return _vm.$refs.audienceUpload.click()
                      }
                    }
                  },
                  [
                    _vm._v(
                      "\n                        " +
                        _vm._s(
                          _vm.resource(
                            "AudienceManager_Builder_SelectCsv_Button"
                          )
                        ) +
                        "\n\n                        "
                    ),
                    _vm._v(" "),
                    _c("input", {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: false,
                          expression: "false"
                        }
                      ],
                      ref: "audienceUpload",
                      attrs: {
                        id: "audience-csv-upload",
                        type: "file",
                        accept: "text/csv"
                      },
                      on: { change: _vm.audienceSelected }
                    })
                  ]
                ),
                _vm._v(" "),
                !this.$v.csvFile.$invalid
                  ? _c("div", [
                      _c("span", [
                        _vm._v(
                          "\n                            " +
                            _vm._s(this.csvFile.name) +
                            "\n                        "
                        )
                      ])
                    ])
                  : _vm._e(),
                _vm._v(" "),
                _vm.displayCsvFileValidationMessage
                  ? [
                      !_vm.$v.csvFile.mustBeCsv
                        ? _c("error-message", {
                            staticClass: "validation-message",
                            attrs: {
                              message: "must be a valid csv file.",
                              "field-name": "csvFile"
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.$v.csvFile.required
                        ? _c("required-error-message", {
                            staticClass: "validation-message",
                            attrs: { "field-name": "csvFile" }
                          })
                        : _vm._e()
                    ]
                  : _vm._e()
              ],
              2
            )
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "question-container" }, [
            _c(
              "label",
              { staticClass: "question-name", attrs: { for: "audience-name" } },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.resource("AudienceEditModel_Name_DisplayName")) +
                    " *\n                "
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "question-content" },
              [
                _c("Input", {
                  staticClass: "question-input",
                  attrs: {
                    id: "audience-name",
                    disabled: !_vm.canEditAudience
                  },
                  model: {
                    value: _vm.audienceNameModel,
                    callback: function($$v) {
                      _vm.audienceNameModel = $$v
                    },
                    expression: "audienceNameModel"
                  }
                }),
                _vm._v(" "),
                _vm.displayAudienceNameValidationMessage
                  ? [
                      !_vm.$v.audienceName.required
                        ? _c("required-error-message", {
                            attrs: {
                              "field-name": _vm.resource(
                                "AudienceEditModel_Name_DisplayName"
                              )
                            }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      !_vm.$v.audienceName.maxLength
                        ? _c("max-length-error-message", {
                            attrs: {
                              "field-name": _vm.resource(
                                "AudienceEditModel_Name_DisplayName"
                              ),
                              "max-length": 255
                            }
                          })
                        : _vm._e()
                    ]
                  : _vm._e()
              ],
              2
            )
          ])
        ])
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }